import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@onefootprint/ui';
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';
import ChatInput from '../chat-input';
import { composerActions } from '../composer-actions';
import ComposerDisclaimer from '../composer-disclaimer';

// Full-width loading skeleton shown while the underlying workflow / agent
// session is fetched. Mirrors the chat-only layout so the page doesn't reflow
// once the session resolves.
const ChatLoadingLayout = () => {
  const $ = _c(16);
  const {
    t
  } = useTranslation("copilot");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoadingSpinner size="large" color="primary" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex-1 flex flex-col items-center overflow-y-auto px-4 pb-4 pt-4"><div className="max-w-[820px] w-full mx-auto flex flex-col items-center flex-1"><div className="flex flex-col items-center justify-center gap-4 flex-1">{t0}<p className="text-body-2 text-shimmer">{t1}</p></div></div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = composerActions({
      env: {}
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="flex flex-col w-full gap-2"><ChatInput {...t3} placeholder={t4} disabled={true} enableEntityMentions={false} onSendMessage={_temp3} rows={2} /></div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ComposerDisclaimer className="w-full" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className="relative px-3 pb-[max(1rem,env(safe-area-inset-bottom))] group-data-[keyboard-open]/app:pb-3 flex flex-col items-center max-w-[820px] w-full mx-auto">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <div className="absolute inset-0 flex overflow-hidden"><div className="flex flex-col w-full bg-primary"><div className="flex-1 min-h-0 relative flex flex-col">{t2}{t7}</div></div></div>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default ChatLoadingLayout;
function _temp($) {
  return $.chat.loadingText;
}
function _temp2($_0) {
  return $_0.chat.replyPlaceholder;
}
async function _temp3() {
  return noop();
}